import Applications from './Applications'

export default Applications
